<main class="content">
  <app-ficha-etapas-cadastro titulo="Cadastrar Nova Ficha" [etapas]="etapas" [etapaAtual]="etapaAtual"></app-ficha-etapas-cadastro>

  <section class="etapas">
    <app-breadcrumb
      [currentPage]="currentPageBreadcrumb"
      [currentPageDetail]="etapaAtual.descricao"
      voltar="hide"
      routerCurrentPage="/nova">
    </app-breadcrumb>

    <div [ngSwitch]="numeroEtapaAtual">
      <app-selecionar-lojista-vendedor
        [operacao]="propostaCadastro.operacao"
        *ngSwitchCase="1"
        [formUpdateEmitter]="formUpdateEmitter"
        [solicitante]="solicitante"
        [(value)]="propostaCadastro.lojaVendedor"
        (valid)="formValid = $event">
      </app-selecionar-lojista-vendedor>

      <app-dados-analise
        #dadosAnalise 
        *ngSwitchCase="2"
        [tipoNegociacaoEnum]="propostaCadastro.produto"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-dados-analise>

      <div *ngSwitchCase="3">
        <app-resultado-parcial
          *ngIf="!statusWebLogic"
          (previous)="onClickPrevious()"
          (next)="onClickNext()">
        </app-resultado-parcial>
      </div>

      <app-consultando-dados
        *ngIf="statusWebLogic"
        (webLogicStatus)="handleWebLogicStatus($event)"
        [idProposta]="this.idPropostaWebLogic.toString()">
      </app-consultando-dados>

      <app-detalhes-cliente
        *ngSwitchCase="4.1"
        [tipoNegociacaoEnum]="propostaCadastro.produto"
        [banco]="propostaCadastro.banco"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-detalhes-cliente>

      <app-dados-complementares
        *ngSwitchCase="4.2"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-dados-complementares>

      <app-enderecos-cliente
        *ngSwitchCase="4.3"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-enderecos-cliente>

      <app-detalhes-cliente
        *ngSwitchCase="5.1"
        [avalistaNumero]="1"
        [banco]="propostaCadastro.banco"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-detalhes-cliente>

      <app-dados-complementares
        *ngSwitchCase="5.2"
        [avalistaNumero]="1"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-dados-complementares>

      <app-enderecos-cliente
        *ngSwitchCase="5.3"
        [avalistaNumero]="1"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-enderecos-cliente>

      <app-detalhes-cliente
        *ngSwitchCase="6.1"
        [avalistaNumero]="2"
        [banco]="propostaCadastro.banco"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-detalhes-cliente>

      <app-dados-complementares
        *ngSwitchCase="6.2"
        [avalistaNumero]="2"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-dados-complementares>

      <app-enderecos-cliente
        *ngSwitchCase="6.3"
        [avalistaNumero]="2"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-enderecos-cliente>

      <app-detalhes-cliente
        *ngSwitchCase="7.1"
        [avalistaNumero]="3"
        [banco]="propostaCadastro.banco"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-detalhes-cliente>

      <app-dados-complementares
        *ngSwitchCase="7.2"
        [avalistaNumero]="3"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-dados-complementares>

      <app-enderecos-cliente
        *ngSwitchCase="7.3"
        [avalistaNumero]="3"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-enderecos-cliente>

      <app-dados-empreendimento
        *ngSwitchCase="8.1"
        (next)="onClickNext()"
        (previous)="onClickPrevious()"
        (loading)="showLoader = $event"
        >
      </app-dados-empreendimento>

      <app-vendas-margem
        *ngSwitchCase="8.2"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-vendas-margem>

      <app-media-vendas
        *ngSwitchCase="8.3"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-media-vendas>

      <app-compras-trimestre
        *ngSwitchCase="8.4"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-compras-trimestre>

      <app-dados-financeiros
        *ngSwitchCase="8.5"
        (next)="onClickNext()"
        (previous)="onClickPrevious()"
        (loading)="showLoader = $event"
        >
      </app-dados-financeiros>

      <app-resultados-contabeis
        *ngSwitchCase="8.6"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-resultados-contabeis>

      <app-parecer-agente
        *ngSwitchCase="8.7"
        (next)="onClickNext()"
        (previous)="onClickPrevious()"
        (loading)="showLoader = $event"
      ></app-parecer-agente>

      <app-identificacao
        *ngSwitchCase="9"
        [numeroEtapaAtual]="numeroEtapaAtual"
        [tipoProduto]="propostaCadastro.tipoProduto"
        (next)="onClickNext()"
        (previous)="onClickPrevious()">
      </app-identificacao>

      <app-analise
        *ngSwitchCase="10">
      </app-analise>
    </div>

    <app-botao-navegacao
      *ngIf="etapaNaoPossuiControleIndependente()"
      (previous)="onClickPrevious()"
      (next)="onClickNext()"
      [previousShow]="isShowButtonPrevious"
      [nextShow]="true"
      [nextEnabled]="formValid || numeroEtapaAtual === 10">
    </app-botao-navegacao>
  </section>
</main>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
